
import {Component, Vue} from "vue-property-decorator";

@Component({
    components: {}
})
export default class Login extends Vue {

    public logo = require('@/assets/login-il.png');
}
